/**
 * Shop 모듈은 API 서버에서 동적 타입으로 저장하고 있기 때문에 클라이언트에서 사용할 프로퍼티를 명시하는 과정이 필요.
 */
import type {
  DTOGemProductModule,
  DTOSubscriptionBenefitModule,
  DTOSubscriptionHeaderModule,
  DTOVividiOneTimePlanModule,
} from 'src/apis/dto/DTOShopModule';
import type { DTOShopPage, DTOVividiPlusPage } from 'src/apis/dto/DTOShopPage';
import type {
  DTOGemProductSection,
  DTOItemProductSection,
  DTOVividiOneTimePlanSection,
} from 'src/apis/dto/DTOShopSection';

export const toVividiOneTimePlanModules = (response: DTOShopPage): DTOVividiOneTimePlanModule[] => {
  return response.sections.flatMap(({ modules }) => {
    if (!modules) {
      return [];
    }

    return modules.filter(
      (module): module is DTOVividiOneTimePlanModule =>
        'moduleType' in module && module.moduleType === 'VIVIDI_ONE_TIME_PLAN'
    );
  });
};

export const toSubscriptionHeaderModules = (
  response: DTOShopPage
): DTOSubscriptionHeaderModule[] => {
  return response.sections.flatMap(({ modules }) => {
    if (!modules) {
      return [];
    }

    return modules.filter(
      (module): module is DTOSubscriptionHeaderModule =>
        'moduleType' in module && module.moduleType === 'SUB_HEADER'
    );
  });
};

export const toSubscriptionBenefitModules = (
  response: DTOShopPage
): DTOSubscriptionBenefitModule[] => {
  return response.sections.flatMap(({ modules }) => {
    if (!modules) {
      return [];
    }

    return modules.filter(
      (module): module is DTOSubscriptionBenefitModule =>
        'moduleType' in module && module.moduleType === 'SUB_BENEFIT'
    );
  });
};

export const isSubscriptionPageExtra = (response: DTOShopPage): response is DTOVividiPlusPage => {
  return 'pageType' in response && response.pageType === 'SUB_PAGE_VIVIDI';
};

export const toOneTimePlanSections = (response: DTOShopPage): DTOVividiOneTimePlanSection[] => {
  return response.sections.filter(
    (section): section is DTOVividiOneTimePlanSection =>
      'sectionType' in section && section.sectionType === 'VIVIDI_ONE_TIME_PLANS'
  );
};

export const getItemProductSections = (page: DTOShopPage): DTOItemProductSection[] => {
  return page.sections.filter(
    (section): section is DTOItemProductSection =>
      'sectionType' in section && section.sectionType === 'ITEM_PRODUCTS'
  );
};

export const getGemProductSections = (page: DTOShopPage): DTOGemProductSection[] => {
  return page.sections.filter(
    (section): section is DTOGemProductSection =>
      'sectionType' in section && section.sectionType === 'GEM_PRODUCTS'
  );
};

export const toGemProductModules = (response: DTOShopPage): DTOGemProductModule[] => {
  return response.sections.flatMap(({ modules }) => {
    if (!modules) return [];

    return modules.filter(
      (module): module is DTOGemProductModule =>
        'moduleType' in module && module.moduleType === 'GEM_PRODUCT'
    );
  });
};
